import React from "react";
import { Helmet } from "react-helmet-async";
import SectionMagazine5 from "./SectionMagazine5";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { useBlog } from "../../hooks/collections/useBlog";

const BlogPage: React.FC = () => {
  const { posts } = useBlog({
    loadData: true,
    queries: [
      { type: "limit", value: 10 },
      { type: "orderBy", direction: "desc", field: "createdAt" }
    ]
  });

  return (
    <div className="nc-BlogPage overflow-hidden relative min-h-screen">
      <Helmet>
        <title>Blog</title>
      </Helmet>
      <BgGlassmorphism/>
      <div className="container relative">
        <div className="pt-12 pb-16 lg:pb-28">
          <SectionMagazine5 posts={posts}/>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
